/* eslint-disable import/default */

import React from 'react';
import {render} from 'react-dom';
import { Provider } from 'react-redux';
import configureStore from './store/configureStore';
import RouletteApp from './components/rouletteApp';
require('./favicon.ico'); // Tell webpack to load favicon.ico
import './styles/styles.scss'; // Yep, that's right. You can import SASS/CSS files too! Webpack will run the associated loader and plug this into the page.

const store = configureStore();
// Create an enhanced history that syncs navigation events with the store

render(
  <Provider store={store}>
    <RouletteApp/>
  </Provider>, document.getElementById('app')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/